import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectOrderDetailsData,
    selectOrderDetailsStatus,
    selectOrderDetailsError,
    initializeAsync,
} from "./orderDetailsSlice";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { CardContainer } from "../../components/CardContainer";
import { AlertDialog } from "../../components/AlertDialog";
import { Typography, Button, Divider } from "@mui/material";
import Link from "@mui/material/Link";
import { useParams, useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/Close";
import { get, post } from "../../api";
import { ImageList, ImageListItem, Skeleton } from "@mui/material";
import { query, save } from "../../services/object";
import { getFileUrl } from "../../services/s3";
import { useMediaQuery } from "@mui/material";
import { format } from "date-fns";
// Add custom imports here

const OrderDetails = () => {
    const data = useSelector(selectOrderDetailsData);
    const status = useSelector(selectOrderDetailsStatus);
    const error = useSelector(selectOrderDetailsError);
    const dispatch = useDispatch();

    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [formData, setFormData] = useState({});
    const [loadingOrderDetails, setLoadingOrderDetails] = useState(true);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [seletedItemToDelete, setSeletedItemToDelete] = useState(null);
    const [qrCodeImage, setQRCodeImage] = useState(null);
    const isDesktop = useMediaQuery("(min-width:1250px)");
    const navigate = useNavigate();
    let { recordId } = useParams();
    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    useEffect(() => {
        if (recordId) {
            get("opportunity/getRecordById", {
                recordId: recordId,
            }).then(async (result) => {
                if (result.isSuccess) {
                    setFormData(result.data[0]);
                    loadDocuments(result.data[0]);

                    setLoadingOrderDetails(false);
                }
            });
            if (userDetails?.signInUserSession?.refreshToken?.token) {
                let data = {
                    signUrl: window.location.host + "/login-with-access",
                    refreshToken: userDetails?.signInUserSession?.refreshToken?.token,
                    redirectUrl: "/locationSurvey/" + recordId,
                    username: userDetails?.username,
                };
                post("qrCode/generateQRCode", data).then((result) => {
                    if (result.isSuccess) {
                        console.log(userDetails);
                        setQRCodeImage(result.data);
                    }
                });
            }
        } else {
            setLoadingOrderDetails(false);
        }
    }, []);

    const loadDocuments = (record) => {
        query("document", "getRelatedRecords", { parentId: record.id }).then((result) => {
            if (result.isSuccess) {
                let documentData = result.data?.filter((item) => !item.isDeleted);
                let newFormValues = { ...record };
                let floorDocuments = documentData.filter((item) => item.localDocumentType === "floorPlan");
                let miscDocuments = documentData.filter((item) => item.localDocumentType === "miscPlan");

                newFormValues.floorPlan = floorDocuments;
                newFormValues.miscPlan = miscDocuments;
                setFormData(newFormValues);
            }
        });
    };

    const handleEdit = (event) => {
        navigate("/donationProject/" + recordId);
    };

    const handleDeleteOrder = (event) => {
        //navigate("/locationSurvey");
        setOpenConfirmModal(true);
    };

    const handleArtLocationSurvey = () => {
        navigate("/locationSurvey/" + recordId);
    };

    const handleArtSelection = () => {
        navigate("/artWorkSelection/" + recordId);
    };

    const handleDeleteAttachment = () => {
        console.info("You clicked the delete icon.");
    };

    const handleDownload = async (event, item) => {
        event.stopPropagation();
        event.preventDefault();
        const { isSuccess, data } = await getFileUrl({
            fileId: item.file ? item.file.fileId : item.fileId,
        });
        if (isSuccess) {
            downloadFile(data, item.name);
        }
    };

    const downloadFile = (downloadUrl, name) => {
        const downloadContainer = document.querySelector(".download-container");
        const fileName = name;

        let a = document.createElement("a");
        a.href = downloadUrl;
        a.target = "_blank";
        // Use a.download if available, it prevents plugins from opening.
        a.download = fileName;
        // Add a to the doc for click to work.
        if (downloadContainer) {
            downloadContainer.appendChild(a);
        }
        if (a.click) {
            a.click(); // The click method is supported by most browsers.
        }
        // Delete the temporary link.
        downloadContainer?.removeChild(a);
    };

    const handleDelete = async (event, document, type) => {
        event.stopPropagation();
        let newFormValues = { ...formData };
        let documents = newFormValues[type];

        let doc = documents?.find((item) => item.id === document.id);

        if (document) {
            if (document.parentId) {
                documents = documents?.map((item) => {
                    if (document.id === item.id) {
                        item.isDeleted = true;
                    }
                    return item;
                });
                document.isDeleted = true;
                let documentResult = await save("document", [document]);
            }
            documents = documents?.filter((item) => doc.id !== item.id);
            newFormValues[type] = documents;
            setFormData(newFormValues);
        }
    };

    const getOrderDetails = () => {
        if (loadingOrderDetails) {
            let content = [1];
            return (
                <ImageList sx={{}} cols={1} gap={1}>
                    {content?.map((item) => (
                        <ImageListItem sx={{ px: 0.5 }} key={item}>
                            <Skeleton variant="rounded" width="100%" height="100%" />
                        </ImageListItem>
                    ))}
                </ImageList>
            );
        }
        if (formData) {
            return (
                <Box sx={{ px: 0, height: "100%", overflow: "auto" }}>
                    <Box sx={{ p: 2, mb: 1 }}>
                        <Typography variant="h3" component="div">
                            {formData?.name}
                        </Typography>

                        <Typography sx={{ lineHeight: 2 }} variant="body1" component="div">
                            {formData?.streetAddress}
                        </Typography>
                    </Box>

                    <Divider></Divider>

                    <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
                        <Typography variant="body1" component="div">
                            Pieces: <strong>{formData?.artPieces}</strong>
                        </Typography>
                        {/* <Typography variant="body1" component="div">
                            Donation: <strong>$TBD</strong>
                        </Typography> */}
                        <Typography variant="body1" component="div">
                            Status: <strong>{formData?.status}</strong>
                        </Typography>
                    </Box>

                    <Divider></Divider>

                    <Box sx={{ display: "flex", p: 2 }}>
                        <Typography variant="body1" component="div">
                            Preferred Installation Date:{" "}
                            <strong>
                                {formData?.installationDate &&
                                    format(new Date(formData?.installationDate), "MMM dd, yyyy")}
                            </strong>
                        </Typography>
                    </Box>
                    {(formData?.floorPlan?.length > 0 || formData?.miscPlan?.length > 0) && (
                        <>
                            <Divider></Divider>
                            <Box sx={{ display: "flex", p: 2, flexWrap: "wrap" }}>
                                {formData?.floorPlan &&
                                    formData.floorPlan.map((file) => (
                                        <>
                                            {!file.isDeleted && (
                                                <Chip
                                                    label={file?.name}
                                                    variant="outlined"
                                                    onDelete={(event) => handleDelete(event, file, "floorPlan")}
                                                    onClick={(event) => handleDownload(event, file)}
                                                    deleteIcon={<CloseIcon sx={{ fontSize: "6px" }} />}
                                                />
                                            )}
                                        </>
                                    ))}
                                {formData?.miscPlan &&
                                    formData.miscPlan.map((file) => (
                                        <>
                                            {!file.isDeleted && (
                                                <Chip
                                                    label={file?.name}
                                                    variant="outlined"
                                                    onDelete={(event) => handleDelete(event, file, "miscPlan")}
                                                    onClick={(event) => handleDownload(event, file)}
                                                    deleteIcon={<CloseIcon />}
                                                />
                                            )}
                                        </>
                                    ))}
                            </Box>
                        </>
                    )}
                    {formData?.projectDescription && (
                        <>
                            <Divider></Divider>
                            <Box sx={{ p: 2 }}>
                                <Typography
                                    sx={{ mr: 4, color: "gray", fontSize: ".7rem" }}
                                    variant="body1"
                                    component="div">
                                    Project Description
                                </Typography>
                                <Typography sx={{ mr: 4 }} variant="body1" component="div">
                                    {formData?.projectDescription}
                                </Typography>
                            </Box>
                        </>
                    )}
                    {formData?.spaceDescription && (
                        <>
                            <Divider></Divider>

                            <Box sx={{ p: 2 }}>
                                <Typography
                                    sx={{ mr: 4, color: "gray", fontSize: ".7rem" }}
                                    variant="body1"
                                    component="div">
                                    Space Description
                                </Typography>
                                <Typography sx={{ mr: 4 }} variant="body1" component="div">
                                    {formData?.spaceDescription}
                                </Typography>
                            </Box>
                        </>
                    )}
                </Box>
            );
        }
    };

    const getViaDesktop = () => {
        return (
            <Box align="center" sx={{ mt: 2, px: 2, width: "100%" }}>
                <Typography component="div" variant="h3" gutterBottom sx={{ maxWidth: "26ch" }}>
                    Via Desktop Computer
                </Typography>
                <Typography component="div" variant="body1" gutterBottom sx={{ maxWidth: "50ch" }}>
                    Use the button below to review and edit your art location survey on your desktop computer.
                </Typography>
                <Button
                    size="large"
                    sx={{ mt: 4 }}
                    variant="contained"
                    onClick={(e) => handleArtLocationSurvey(e)}
                    id="locationSurvey">
                    Art location survey
                </Button>
            </Box>
        );
    };
    const getViaMobile = () => {
        return (
            <Box align="center" sx={{ mt: 2, px: 2 }}>
                <Typography component="div" variant="h3" gutterBottom sx={{ maxWidth: "26ch" }}>
                    Via Mobile Device
                </Typography>
                <Typography component="div" variant="body1" gutterBottom sx={{ maxWidth: "50ch" }}>
                    Scan this QR code with your phone's camera app to open the art location survey and begin cataloging
                    wall locations, dimensions, and wall image using a mobile device.{" "}
                </Typography>
                {qrCodeImage && (
                    <Box
                        component="img"
                        sx={{
                            mt: 3,
                            height: "80dvh",
                            width: 250,
                            maxHeight: { xs: 200, md: 160 },
                            maxWidth: { xs: 250, md: 150 },
                            border: "2px solid #0080ff",
                            borderRadius: "8px",
                        }}
                        alt="The house from the offer."
                        src={qrCodeImage}
                    />
                )}
                <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
                    <Link href="#" underline="always">
                        <Typography variant="body1">Need help? Reach out for assistance</Typography>
                    </Link>

                    {/* <Button
            size="large"
            sx={{ mt: 4 }}
            variant="contained"
            onClick={(e) => handleArtSelection(e)}
            id="locationSurvey"
          >
            Art selection
      </Button>*/}
                </Box>
            </Box>
        );
    };

    const handleDisagree = () => {
        setOpenConfirmModal(false);
        setSeletedItemToDelete(null);
    };

    const handleAgree = async () => {
        post("opportunity/deleteRecordById", {
            recordId: recordId,
        }).then(async (result) => {
            if (result.isSuccess) {
                setOpenConfirmModal(false);
                setSeletedItemToDelete(null);
                navigate("/");
            }
        });
    };

    let body = (
        <Box sx={{ py: { xs: 3, md: 3, lg: 5 }, px: { xs: 3, md: 3, lg: 6 } }}>
            <Grid
                container
                spacing={3}
                justify="center"
                sx={{
                    justifyContent: formData?.status === "In-Progress" ? "none" : "center",
                }}>
                <Grid item xs={12} sm={12} md={6}>
                    <Box sx={{ mt: 1, textAlign: "center" }}>
                        <Typography
                            component="div"
                            variant="h3"
                            gutterBottom
                            sx={{ textAlign: "center", mb: 6, fontSize: "1.7rem" }}>
                            Donation Project Details
                        </Typography>
                    </Box>

                    <CardContainer
                        px={0}
                        m={0}
                        height="calc(100vh - 12rem)"
                        contentOnCenter={false}
                        actions={
                            <Box sx={{ width: "100%", backgroundColor: "white", border: "1px solid #E8E8E8", mt: 2 }}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        p: 2,
                                    }}>
                                    <Button
                                        variant="outlined"
                                        onClick={(e) => handleEdit(e)}
                                        id="donationOrder"
                                        size="small">
                                        Edit details
                                    </Button>

                                    {formData?.status === "In-Progress" && (
                                        <Button
                                            variant="outlined"
                                            onClick={(e) => handleDeleteOrder(e)}
                                            id="favourite"
                                            size="small"
                                            color="error">
                                            Delete project
                                        </Button>
                                    )}

                                    {formData?.status === "Survey Approved" && (
                                        <Button
                                            variant="outlined"
                                            id="favourite"
                                            size="small"
                                            color="success"
                                            disabled={formData?.status !== "Survey Approved"}
                                            onClick={handleArtSelection}>
                                            Select artwork
                                        </Button>
                                    )}
                                    {(formData?.status === "Artwork Submitted" ||
                                        formData?.status === "Artwork Selection Approved" ||
                                        formData?.status === "Completed") && (
                                        <Button
                                            variant="outlined"
                                            id="favourite"
                                            size="small"
                                            color="success"
                                            onClick={handleArtSelection}>
                                            View artwork selection
                                        </Button>
                                    )}
                                </Box>
                            </Box>
                        }>
                        {getOrderDetails()}
                    </CardContainer>
                </Grid>
                {formData?.status === "In-Progress" && (
                    <Grid item xs={12} sm={12} md={6} spacing={2} sx={{ height: "calc(100vh - 12rem)" }}>
                        <Box sx={{ height: "calc(100vh - 12rem)" }}>
                            <Box sx={{ mt: 1, textAlign: "center" }}>
                                <Typography
                                    component="div"
                                    variant="h3"
                                    gutterBottom
                                    sx={{ textAlign: "center", mb: 6, fontSize: "1.7rem" }}>
                                    Access Art Location Survey
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    border: "1px solid #B8B8B8",
                                    borderRadius: "8px",
                                    py: 1.5,
                                    height: "200px",
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                }}>
                                {getViaDesktop()}
                            </Box>
                            <Box
                                sx={{
                                    border: "1px solid #B8B8B8",
                                    borderRadius: "8px",
                                    py: 1.5,
                                    mt: "1rem",
                                    position: "relative",
                                    height: { xs: "auto", md: "calc(100% - 215px)" },
                                    justifyContent: "center",
                                    alignItems: "center",
                                    overflow: "scroll",
                                }}>
                                {getViaMobile()}
                            </Box>
                        </Box>
                    </Grid>
                )}
            </Grid>
            <AlertDialog
                title="Confirm"
                message="Are you sure, you want to delete this project?"
                open={openConfirmModal}
                onDisagree={handleDisagree}
                onAgree={handleAgree}></AlertDialog>
        </Box>
    );

    return getPageContent(body, status, error);
};

export { OrderDetails };
